import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { HttpClientModule } from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './store/effects/auth.effects';
import { DoctorEffects } from './store/effects/doctor.effects';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuardService as AuthGuard } from './services/auth-guard.service';
import { AppComponent } from './app.component';
import { PatientPanelComponent } from './components/doctor-management/patient-panel/patient-panel.component';
import { StartupComponent } from './components/startup/startup.component';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoginComponent } from './components/user-actions/login/login.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { RouteConfig } from './config/route.config';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
// tslint:disable-next-line:max-line-length
import { QuestionnaireIbdDiskComponent } from './components/patient-management/questionnaires-all/questionnaire-ibd-disk/questionnaire-ibd-disk.component';
import { MatTableModule } from '@angular/material/table';
import { SuccessComponent } from './components/user-actions/success/success.component';
import { ErrorComponent } from './components/user-actions/error/error.component';
import { MatListModule } from '@angular/material/list';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { RegistrationComponent } from './components/user-actions/registration/registration.component';
import { PasswordChangeComponent } from './components/pwd-management/password-change/password-change.component';
import { ErrorDialogComponent } from './components/user-actions/error-dialog/error-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ChartsModule } from 'ng2-charts';
import { AuthService } from './services/auth.service';
import { StoreModule } from '@ngrx/store';
import { reducers } from './store/app.states';
import { LandingComponent } from './components/page-composition/landing/landing.component';
import { ErrorInterceptor, TokenInterceptor } from './services/token.interceptor';
import { BoxComponent } from './components/page-composition/box/box.component';
import { ToolbarComponent } from './components/page-composition/toolbar/toolbar.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { PatientsControlPanelComponent } from './components/doctor-management/patients-control-panel/patients-control-panel.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { QuestionnairesComponent } from './components/patient-management/questionnaires/questionnaires.component';
// tslint:disable-next-line:max-line-length
import { QuestionnaireEq5d5lComponent } from './components/patient-management/questionnaires-all/questionnaire-eq5d5l/questionnaire-eq5d5l.component';
// tslint:disable-next-line:max-line-length
import { QuestionnaireEortcQlqComponent } from './components/patient-management/questionnaires-all/questionnaire-eortc-qlq/questionnaire-eortc-qlq.component';
// tslint:disable-next-line:max-line-length
import { QuestionnaireTsqmComponent } from './components/patient-management/questionnaires-all/questionnaire-tsqm/questionnaire-tsqm.component';
// tslint:disable-next-line:max-line-length
import { QuestionnaireSibdqComponent } from './components/patient-management/questionnaires-all/questionnaire-sibdq/questionnaire-sibdq.component';
import {
  QuestionnaireWpaiComponent
} from './components/patient-management/questionnaires-all/questionnaire-wpai/questionnaire-wpai.component';
// tslint:disable-next-line:max-line-length
import { HbiDialogComponent, QuestionnaireHbiComponent } from './components/patient-management/questionnaires-all/questionnaire-hbi/questionnaire-hbi.component';
// tslint:disable-next-line:max-line-length
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PatientRegistrationComponent } from './components/doctor-management/patient-registration/patient-registration.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import {
  AddJobDialogComponent,
  PatientQuestionnairePanelComponent,
} from './components/doctor-management/patient-questionnaire-panel/patient-questionnaire-panel.component';
import { QuestionnaireAddDialogComponent } from './components/doctor-management/patient-questionnaire-panel/questionnaire-add-dialog';
import {
  DialogService,
} from './services/dialog.service';
// tslint:disable-next-line:max-line-length
import { PatientQuestionnairesShowComponent } from './components/doctor-management/patient-questionnaires-show/patient-questionnaires-show.component';
import { ConfirmDialogComponent } from './components/user-actions/confirm-dialog/confirm-dialog.component';
import { PasswordChangeConfirmComponent } from './components/pwd-management/password-change-confirm/password-change-confirm.component';
import { SidenavComponent } from './components/page-composition/sidenav/sidenav.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatBadgeModule } from '@angular/material/badge';
import { HammerConfig } from './config/hammer-config';
import { ConfirmedComponent } from './components/user-actions/confirmed/confirmed.component';
import { PatientEffects } from './store/effects/patient.effects';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';
import { MessagingService } from './services/messaging.service';
import { AsyncPipe, DatePipe } from '@angular/common';
import { NotificationsComponent } from './components/page-composition/notifications/notifications.component';
import { InfoDialogComponent } from './components/user-actions/info-dialog/info-dialog.component';
// tslint:disable-next-line:max-line-length
import { QuestionnairesCompletedComponent } from './components/patient-management/questionnaires-completed/questionnaires-completed.component';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { QuestionnairesShowComponent } from './components/patient-management/questionnaires-show/questionnaires-show.component';
import { PatientService } from './services/patient.service';
import { SettingsComponent } from './components/page-composition/settings/settings.component';
import { SettingsService } from './services/settings.service';
import { QuestionnaireService } from './services/questionnaire.service';
import { RegistrationService } from './services/registration.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { GdprDialogComponent } from './components/user-actions/gdpr-dialog/gdpr-dialog.component';
import { PingService } from './services/ping.service';
// tslint:disable-next-line:max-line-length
import { QuestionnaireClinicalSCCAIComponent } from './components/patient-management/questionnaires-all/questionnaire-clinical-sccai/questionnaire-clinical-sccai.component';
// tslint:disable-next-line:max-line-length
import { QuestionnairePatientSCCAIComponent } from './components/patient-management/questionnaires-all/questionnaire-patient-sccai/questionnaire-patient-sccai.component';
// tslint:disable-next-line:max-line-length
import { QuestionnaireIpaqSfComponent } from './components/patient-management/questionnaires-all/questionnaire-ipaq-sf/questionnaire-ipaq-sf.component';
// tslint:disable-next-line:max-line-length
import { QuestionnaireHadsComponent } from './components/patient-management/questionnaires-all/questionnaire-hads/questionnaire-hads.component';
// tslint:disable-next-line:max-line-length
import { QuestionnaireMmas8Component } from './components/patient-management/questionnaires-all/questionnaire-mmas8/questionnaire-mmas8.component';
// tslint:disable-next-line:max-line-length
import { QuestionnaireDataConsentComponent } from './components/patient-management/questionnaires-all/questionnaire-data-consent/questionnaire-data-consent.component';
// tslint:disable-next-line:max-line-length
import { QuestionnairePhq9Component } from './components/patient-management/questionnaires-all/questionnaire-phq9/questionnaire-phq9.component';
// tslint:disable-next-line:max-line-length
import { QuestionnairePsqiComponent } from './components/patient-management/questionnaires-all/questionnaire-psqi/questionnaire-psqi.component';
// tslint:disable-next-line:max-line-length
import { QuestionnaireMiahCdComponent } from './components/patient-management/questionnaires-all/questionnaire-miah-cd/questionnaire-miah-cd.component';
// tslint:disable-next-line:max-line-length
import { QuestionnaireMiahUcComponent } from './components/patient-management/questionnaires-all/questionnaire-miah-uc/questionnaire-miah-uc.component';
// tslint:disable-next-line:max-line-length
import { QuestionnairePrismComponent } from './components/patient-management/questionnaires-all/questionnaire-prism/questionnaire-prism.component';
import { QuestionnaireEvaluationComponent } from './services/dialogs/questionnaire-evaluation/questionnaire-evaluation.component';
import { ClinicalSccaiResultDialogComponent } from './services/dialogs/clinical-sccai-result-dialog/clinical-sccai-result-dialog.component';
import { EORTCResultDialogComponent } from './services/dialogs/eortc-result-dialog/eortc-result-dialog.component';
import { EQ5D5LResultDialogComponent } from './services/dialogs/eq5-d5-l-result-dialog/eq5-d5-l-result-dialog.component';
import { HADSResultDialogComponent } from './services/dialogs/hads-result-dialog/hads-result-dialog.component';
import { HBIResultDialogComponent } from './services/dialogs/hbi-result-dialog/hbi-result-dialog.component';
import { IBDDiskResultDialogComponent } from './services/dialogs/ibddisk-result-dialog/ibddisk-result-dialog.component';
import { IPAQSFResultDialogComponent } from './services/dialogs/ipaqsf-result-dialog/ipaqsf-result-dialog.component';
import { MIAHCDResultDialogComponent } from './services/dialogs/miahcd-result-dialog/miahcd-result-dialog.component';
import { MIAHUCResultDialogComponent } from './services/dialogs/miahuc-result-dialog/miahuc-result-dialog.component';
import { MMAS8ResultDialogComponent } from './services/dialogs/mmas8-result-dialog/mmas8-result-dialog.component';
import { PatientSCCAIResultDialogComponent } from './services/dialogs/patient-sccai-result-dialog/patient-sccai-result-dialog.component';
import { PHQ9ResultDialogComponent } from './services/dialogs/phq9-result-dialog/phq9-result-dialog.component';
import { PSQIResultDialogComponent } from './services/dialogs/psqi-result-dialog/psqi-result-dialog.component';
import { SIBDQResultDialogComponent } from './services/dialogs/sibdq-result-dialog/sibdq-result-dialog.component';
import { TSQMResultDialogComponent } from './services/dialogs/tsqm-result-dialog/tsqm-result-dialog.component';
import { WPAIResultDialogComponent } from './services/dialogs/wpai-result-dialog/wpai-result-dialog.component';
import { PRISMResultDialogComponent } from './services/dialogs/prism-result-dialog/prism-result-dialog.component';
import { MatSliderModule } from '@angular/material/slider';
// tslint:disable-next-line:max-line-length
import { PatientsGlobalControlPanelComponent } from './components/doctor-management/patients-global-control-panel/patients-global-control-panel.component';
// tslint:disable-next-line:max-line-length
import { PatientClinicalPendingsComponent } from './components/doctor-management/patient-clinical-pendings/patient-clinical-pendings.component';
// tslint:disable-next-line:max-line-length
import { QuestionnaireClinicalHbiComponent } from './components/patient-management/questionnaires-all/questionnaire-clinical-hbi/questionnaire-clinical-hbi.component';
// tslint:disable-next-line:max-line-length
import { QuestionnaireClinicalPrismComponent } from './components/patient-management/questionnaires-all/questionnaire-clinical-prism/questionnaire-clinical-prism.component';
import { QuestionnairesSummaryComponent } from './components/doctor-management/questionnaires-summary/questionnaires-summary.component';
import { MatSortModule } from '@angular/material/sort';
import { InactivePatientsSummaryComponent } from './components/doctor-management/inactive-patients-summary/inactive-patients-summary.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ContactCenterComponent } from './components/patient-management/contact-center/contact-center.component';
import { ChooseQuestionnaireComponent } from './components/patient-management/contact-center/choose-questionnaire/choose-questionnaire.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { PatientChatComponent } from './components/patient-management/contact-center/patient-chat/patient-chat.component';
import { DoctorChatComponent } from './components/doctor-management/doctor-chat/doctor-chat.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AttachFileDialogComponent } from './services/dialogs/attach-file-dialog/attach-file-dialog.component';
import { QuestionnaireIbdqComponent } from './components/patient-management/questionnaires-all/questionnaire-ibdq/questionnaire-ibdq.component';
import { IBDQResultDialogComponent } from './services/dialogs/ibdq-result-dialog/ibdq-result-dialog.component';
import { GeneralStatusComponent } from './components/doctor-management/general-status/general-status.component';
import { BarChartNeverLoggedComponent } from './components/doctor-management/general-status/bar-chart-never-logged/bar-chart-never-logged.component';
import { BarChartInactivePatientsComponent } from './components/doctor-management/general-status/bar-chart-inactive-patients/bar-chart-inactive-patients.component';
import { DoughnutChartGlobalPatientsComponent } from './components/doctor-management/general-status/doughnut-chart-global-patients/doughnut-chart-global-patients.component';
import { DoughnutChartPersonalPatientsComponent } from './components/doctor-management/general-status/doughnut-chart-personal-patients/doughnut-chart-personal-patients.component';
import { BarChartStableUnstableUCComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-UC/bar-chart-stable-unstable-uc.component';
import { BarChartStableUnstableCrohnComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-Crohn/bar-chart-stable-unstable-crohn.component';
import { ExportDataComponent } from './components/doctor-management/export-data/export-data.component';
import { ExcelService } from './services/excel.service';
import { PasswordSettingComponent } from './components/pwd-management/password-setting/password-setting.component';
import { InfoClinicalDialogComponent } from './components/user-actions/info-clinical-dialog/info-clinical-dialog.component';
import { ConfirmDialogMultilinesComponent } from './components/user-actions/confirm-dialog-multilines/confirm-dialog-multilines.component';
import { CdUcDataComponent } from './components/doctor-management/export-data/cd-uc-data/cd-uc-data.component';
import { BarChartNeverLoggedCategoryComponent } from './components/doctor-management/general-status/bar-chart-never-logged-category/bar-chart-never-logged-category.component';
import { BarChartNeverLoggedPathologyComponent } from './components/doctor-management/general-status/bar-chart-never-logged-pathology/bar-chart-never-logged-pathology.component';
import { BarChartNeverLoggedSexComponent } from './components/doctor-management/general-status/bar-chart-never-logged-sex/bar-chart-never-logged-sex.component';
import { BarChartNeverLoggedAgeComponent } from './components/doctor-management/general-status/bar-chart-never-logged-age/bar-chart-never-logged-age.component';
import { BarChartNeverLoggedActivetherapyComponent } from './components/doctor-management/general-status/bar-chart-never-logged-activetherapy/bar-chart-never-logged-activetherapy.component';
import { BarChartNeverLoggedInterventiComponent } from './components/doctor-management/general-status/bar-chart-never-logged-interventi/bar-chart-never-logged-interventi.component';
import { BarChartNeverLoggedAgeOfDiagnosisComponent } from './components/doctor-management/general-status/bar-chart-never-logged-age-of-diagnosis/bar-chart-never-logged-age-of-diagnosis.component';
import { BarChartNeverLoggedPathologyDurationComponent } from './components/doctor-management/general-status/bar-chart-never-logged-pathology-duration/bar-chart-never-logged-pathology-duration.component';
import { BarChartNeverLoggedAgeFromUserComponent } from './components/doctor-management/general-status/bar-chart-never-logged-age-from-user/bar-chart-never-logged-age-from-user.component';
import { BarChartNeverLoggedPathologyDurationFromUserComponent } from './components/doctor-management/general-status/bar-chart-never-logged-pathology-duration-from-user/bar-chart-never-logged-pathology-duration-from-user.component';
import { NeverLoggedComponent } from './components/doctor-management/general-status/never-logged/never-logged.component';
import { BoxDashboardComponent } from './components/page-composition/box-dashboard/box-dashboard.component';
import { ResultsComponent } from './components/doctor-management/general-status/results/results.component';
import { BarChartInactiveAgeComponent } from './components/doctor-management/general-status/bar-chart-inactive-age/bar-chart-inactive-age.component';
import { BarChartInactiveAgeFromUserComponent } from './components/doctor-management/general-status/bar-chart-inactive-age-from-user/bar-chart-inactive-age-from-user.component';
import { BarChartInactiveActivetherapyComponent } from './components/doctor-management/general-status/bar-chart-inactive-activetherapy/bar-chart-inactive-activetherapy.component';
import { BarChartInactiveAgeOfDiagnosisComponent } from './components/doctor-management/general-status/bar-chart-inactive-age-of-diagnosis/bar-chart-inactive-age-of-diagnosis.component';
import { BarChartInactiveCategoryComponent } from './components/doctor-management/general-status/bar-chart-inactive-category/bar-chart-inactive-category.component';
import { BarChartInactiveInterventiComponent } from './components/doctor-management/general-status/bar-chart-inactive-interventi/bar-chart-inactive-interventi.component';
import { BarChartInactivePathologyComponent } from './components/doctor-management/general-status/bar-chart-inactive-pathology/bar-chart-inactive-pathology.component';
import { BarChartInactivePathologyDurationComponent } from './components/doctor-management/general-status/bar-chart-inactive-pathology-duration/bar-chart-inactive-pathology-duration.component';
import { BarChartInactivePathologyDurationFromUserComponent } from './components/doctor-management/general-status/bar-chart-inactive-pathology-duration-from-user/bar-chart-inactive-pathology-duration-from-user.component';
import { BarChartInactiveSexComponent } from './components/doctor-management/general-status/bar-chart-inactive-sex/bar-chart-inactive-sex.component';
import { InactiveComponent } from './components/doctor-management/general-status/inactive/inactive.component';
import { BarChartInactiveMalattiaInizialeComponent } from './components/doctor-management/general-status/bar-chart-inactive-malattia-iniziale/bar-chart-inactive-malattia-iniziale.component';
import { FeaturesStableUnstableComponent } from './components/doctor-management/general-status/features-stable-unstable/features-stable-unstable.component';
import { GlobalQuestionnairesPerTypeComponent } from './components/doctor-management/general-status/global-questionnaires-per-type/global-questionnaires-per-type.component';
import { QuestionnaireGradimentoComponent } from './components/patient-management/questionnaires-all/questionnaire-gradimento/questionnaire-gradimento.component';
import { BarChartInactiveMalattiaInizialeMiahComponent } from './components/doctor-management/general-status/bar-chart-inactive-malattia-iniziale-miah/bar-chart-inactive-malattia-iniziale-miah.component';
import { BarChartStableUnstableGenderUCComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-gender-UC/bar-chart-stable-unstable-gender-uc.component';
import { BarChartQuestionnairesTotalComponent } from './components/doctor-management/general-status/bar-chart-questionnaires-total/bar-chart-questionnaires-total.component';
import { BarChartQuestionnairesAvgComponent } from './components/doctor-management/general-status/bar-chart-questionnaires-avg/bar-chart-questionnaires-avg.component';
import { BarChartStableUnstableGenderCrohnComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-gender-crohn/bar-chart-stable-unstable-gender-crohn.component';
import { BarChartStableUnstablePreviousSurgeryCrohnComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-previous-surgery-crohn/bar-chart-stable-unstable-previous-surgery-crohn.component';
import { BarChartStableUnstablePreviousSurgeryUCComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-previous-surgery-uc/bar-chart-stable-unstable-previous-surgery-uc.component';
import { BarChartStableUnstableTherapyUCComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-therapy-uc/bar-chart-stable-unstable-therapy-uc.component';
import { BarChartStableUnstableTherapyCrohnComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-therapy-crohn/bar-chart-stable-unstable-therapy-crohn.component';
import { BarChartStableUnstableAgeUCComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-age-uc/bar-chart-stable-unstable-age-uc.component';
import { BarChartStableUnstableAgeCrohnComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-age-crohn/bar-chart-stable-unstable-age-crohn.component';
import { BarChartStableUnstableDurationCrohnComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-duration-crohn/bar-chart-stable-unstable-duration-crohn.component';
import { BarChartStableUnstableDurationUCComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-duration-uc/bar-chart-stable-unstable-duration-uc.component';
import { BarChartStableUnstableInitialActiveInactivePathologyCrohnComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-initial-active-inactive-pathology-crohn/bar-chart-stable-unstable-initial-active-inactive-pathology-crohn.component';
import { BarChartStableUnstableInitialActiveInactivePathologyUCComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-initial-active-inactive-pathology-uc/bar-chart-stable-unstable-initial-active-inactive-pathology-uc.component';
import { BarChartAverageQuestionnairesPerPatientComponent } from './components/doctor-management/general-status/bar-chart-average-questionnaires-per-patient/bar-chart-average-questionnaires-per-patient.component';
import { TableQuestionnairesComponent } from './components/doctor-management/general-status/table-questionnaires/table-questionnaires.component';
import { StableUnstablePathologySectionComponent } from './components/doctor-management/general-status/stable-unstable-pathology-section/stable-unstable-pathology-section.component';
import { StableUnstableAgeSectionComponent } from './components/doctor-management/general-status/stable-unstable-age-section/stable-unstable-age-section.component';
import { StableUnstableDurationSectionComponent } from './components/doctor-management/general-status/stable-unstable-duration-section/stable-unstable-duration-section.component';
import { StableUnstableGenderSectionComponent } from './components/doctor-management/general-status/stable-unstable-gender-section/stable-unstable-gender-section.component';
import { StableUnstableInterventiSectionComponent } from './components/doctor-management/general-status/stable-unstable-interventi-section/stable-unstable-interventi-section.component';
import { StableUnstableMalattiaInizialeSectionComponent } from './components/doctor-management/general-status/stable-unstable-malattia-iniziale-section/stable-unstable-malattia-iniziale-section.component';
import { StableUnstableTherapyActiveSectionComponent } from './components/doctor-management/general-status/stable-unstable-therapy-active-section/stable-unstable-therapy-active-section.component';
import { BarChartStableUnstableInitialActiveInactivePathologyMiahCrohnComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-initial-active-inactive-pathology-miah-crohn/bar-chart-stable-unstable-initial-active-inactive-pathology-miah-crohn.component';
import { BarChartStableUnstableInitialActiveInactivePathologyMiahUCComponent } from './components/doctor-management/general-status/bar-chart-stable-unstable-initial-active-inactive-pathology-miah-uc/bar-chart-stable-unstable-initial-active-inactive-pathology-miah-uc.component';
import { DoughnutChartAverageRetentionComponent } from './components/doctor-management/general-status/doughnut-chart-average-retention/doughnut-chart-average-retention.component';
import { QuestionarioGradimentoComponent } from './components/doctor-management/general-status/questionario-gradimento/questionario-gradimento.component';
import { AnnouncementDoctorComponent } from './components/doctor-management/announcement-doctor/announcement-doctor.component';
import { AnnouncementsForPatientsComponent } from './components/patient-management/announcements-for-patients/announcements-for-patients.component';
import { FaqComponent } from './components/patient-management/faq/faq.component';
import { QuestionnaireLarsComponent } from './components/patient-management/questionnaires-all/questionnaire-lars/questionnaire-lars.component';
import { LarsResultDialogComponent } from './services/dialogs/lars-result-dialog/lars-result-dialog.component';
import { AnalysesDataComponent } from './components/doctor-management/export-data/analyses-data/analyses-data.component';

@NgModule({
  declarations: [
    AppComponent,
    PatientPanelComponent,
    StartupComponent,
    LoginComponent,
    QuestionnaireIbdDiskComponent,
    SuccessComponent,
    ErrorComponent,
    RegistrationComponent,
    PasswordChangeComponent,
    ErrorDialogComponent,
    HbiDialogComponent,
    LandingComponent,
    BoxComponent,
    ToolbarComponent,
    PatientsControlPanelComponent,
    QuestionnairesComponent,
    QuestionnaireEq5d5lComponent,
    QuestionnaireEortcQlqComponent,
    QuestionnaireTsqmComponent,
    QuestionnaireSibdqComponent,
    QuestionnaireWpaiComponent,
    QuestionnaireHbiComponent,
    PatientRegistrationComponent,
    PatientQuestionnairePanelComponent,
    PatientQuestionnairesShowComponent,
    ConfirmDialogComponent,
    AddJobDialogComponent,
    PasswordChangeConfirmComponent,
    SidenavComponent,
    QuestionnaireAddDialogComponent,
    ConfirmedComponent,
    NotificationsComponent,
    InfoDialogComponent,
    QuestionnairesCompletedComponent,
    QuestionnairesShowComponent,
    SettingsComponent,
    GdprDialogComponent,
    QuestionnaireClinicalSCCAIComponent,
    QuestionnairePatientSCCAIComponent,
    QuestionnaireIpaqSfComponent,
    QuestionnaireHadsComponent,
    QuestionnaireMmas8Component,
    QuestionnairePhq9Component,
    QuestionnairePsqiComponent,
    QuestionnaireMiahCdComponent,
    QuestionnaireMiahUcComponent,
    QuestionnairePrismComponent,
    GdprDialogComponent,
    QuestionnaireEvaluationComponent,
    ClinicalSccaiResultDialogComponent,
    EORTCResultDialogComponent,
    EQ5D5LResultDialogComponent,
    HADSResultDialogComponent,
    HBIResultDialogComponent,
    IBDDiskResultDialogComponent,
    IPAQSFResultDialogComponent,
    MIAHCDResultDialogComponent,
    MIAHUCResultDialogComponent,
    MMAS8ResultDialogComponent,
    PatientSCCAIResultDialogComponent,
    PHQ9ResultDialogComponent,
    PSQIResultDialogComponent,
    SIBDQResultDialogComponent,
    TSQMResultDialogComponent,
    WPAIResultDialogComponent,
    PRISMResultDialogComponent,
    PatientsGlobalControlPanelComponent,
    PatientClinicalPendingsComponent,
    QuestionnaireClinicalHbiComponent,
    QuestionnaireClinicalPrismComponent,
    QuestionnairesSummaryComponent,
    InactivePatientsSummaryComponent,
    ContactCenterComponent,
    ChooseQuestionnaireComponent,
    PatientChatComponent,
    DoctorChatComponent,
    AttachFileDialogComponent,
    QuestionnaireIbdqComponent,
    IBDQResultDialogComponent,
    GeneralStatusComponent,
    BarChartNeverLoggedComponent,
    BarChartInactivePatientsComponent,
    BarChartStableUnstableGenderUCComponent,
    BarChartStableUnstableGenderCrohnComponent,
    BarChartStableUnstablePreviousSurgeryCrohnComponent,
    BarChartStableUnstablePreviousSurgeryUCComponent,
    BarChartStableUnstableTherapyUCComponent,
    BarChartStableUnstableTherapyCrohnComponent,
    BarChartStableUnstableAgeCrohnComponent,
    BarChartStableUnstableAgeUCComponent,
    BarChartStableUnstableDurationCrohnComponent,
    BarChartStableUnstableDurationUCComponent,
    BarChartStableUnstableInitialActiveInactivePathologyCrohnComponent,
    BarChartStableUnstableInitialActiveInactivePathologyUCComponent,
    DoughnutChartGlobalPatientsComponent,
    DoughnutChartPersonalPatientsComponent,
    DoughnutChartAverageRetentionComponent,
    BarChartStableUnstableInitialActiveInactivePathologyMiahUCComponent,
    BarChartStableUnstableInitialActiveInactivePathologyMiahCrohnComponent,
    BarChartStableUnstableUCComponent,
    BarChartStableUnstableCrohnComponent,
    BarChartQuestionnairesTotalComponent,
    BarChartQuestionnairesAvgComponent,
    BarChartAverageQuestionnairesPerPatientComponent,
    TableQuestionnairesComponent,
    ExportDataComponent,
    CdUcDataComponent,
    AnalysesDataComponent,
    PasswordSettingComponent,
    InfoClinicalDialogComponent,
    ConfirmDialogMultilinesComponent,
    BarChartNeverLoggedCategoryComponent,
    BarChartNeverLoggedPathologyComponent,
    BarChartNeverLoggedSexComponent,
    BarChartNeverLoggedAgeComponent,
    BarChartNeverLoggedActivetherapyComponent,
    BarChartNeverLoggedInterventiComponent,
    BarChartNeverLoggedAgeOfDiagnosisComponent,
    BarChartNeverLoggedPathologyDurationComponent,
    BarChartNeverLoggedAgeFromUserComponent,
    BarChartNeverLoggedPathologyDurationFromUserComponent,
    NeverLoggedComponent,
    BoxDashboardComponent,
    ResultsComponent,
    BarChartInactiveAgeComponent,
    BarChartInactiveAgeFromUserComponent,
    BarChartInactiveActivetherapyComponent,
    BarChartInactiveAgeOfDiagnosisComponent,
    BarChartInactiveCategoryComponent,
    BarChartInactiveInterventiComponent,
    BarChartInactivePathologyComponent,
    BarChartInactivePathologyDurationComponent,
    BarChartInactivePathologyDurationFromUserComponent,
    BarChartInactiveSexComponent,
    InactiveComponent,
    BarChartInactiveMalattiaInizialeComponent,
    FeaturesStableUnstableComponent,
    GlobalQuestionnairesPerTypeComponent,
    QuestionnaireGradimentoComponent,
    BarChartInactiveMalattiaInizialeMiahComponent,
    StableUnstablePathologySectionComponent,
    StableUnstableAgeSectionComponent,
    StableUnstableDurationSectionComponent,
    StableUnstableGenderSectionComponent,
    StableUnstableInterventiSectionComponent,
    StableUnstableMalattiaInizialeSectionComponent,
    StableUnstableTherapyActiveSectionComponent,
    QuestionarioGradimentoComponent,
    AnnouncementDoctorComponent,
    AnnouncementsForPatientsComponent,
    FaqComponent,
    QuestionnaireLarsComponent,
    LarsResultDialogComponent,
    QuestionnaireDataConsentComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HammerModule,
    MatCardModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatIconModule,
    RouteConfig,
    MatButtonModule,
    MatDividerModule,
    FlexModule,
    FlexLayoutModule,
    MatInputModule,
    MatSelectModule,
    MatTableModule,
    FormsModule,
    MatListModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatProgressBarModule,
    ChartsModule,
    MatSnackBarModule,
    StoreModule.forRoot(
      reducers
      /*{metaReducers: [authSync]}*/
    ),
    EffectsModule.forRoot([AuthEffects, DoctorEffects, PatientEffects]),
    StoreDevtoolsModule.instrument({
      maxAge: 25 // Retains last 25 states
      // logOnly: environment.production, // Restrict extension to log-only mode
    }),
    RouterModule,
    MatExpansionModule,
    MatMenuModule,
    MatRadioModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSidenavModule,
    MatBadgeModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    ServiceWorkerModule.register('ngsw-custom.js', { enabled: environment.production }),
    MatSliderModule,
    MatSortModule,
    MatTooltipModule,
    MatGridListModule,
    MatSlideToggleModule,
    FormsModule
  ],
  providers:
    [
      AuthService, AuthGuard,
      MatDatepickerModule, MessagingService,
      AsyncPipe, PatientService, ExcelService,
      DialogService, SettingsService, QuestionnaireService, RegistrationService, PingService, DatePipe,
      {
        provide: MAT_DATE_LOCALE,
        useValue: 'it-IT'
      },
      {
        provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]
      },
      {
        provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS
      },
      {
        provide: HAMMER_GESTURE_CONFIG,
        useClass: HammerConfig
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: TokenInterceptor,
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: ErrorInterceptor,
        multi: true
      }
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
